import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ApplicationState } from "@/store";

export const usePendingFilterState = () => {
  const filterState = useSelector(
    (state: ApplicationState) => state.priceRemarkPendingFilter,
  );
  return useMemo(() => filterState, [filterState]);
};
